import React from 'react';
import {Checkbox as SemanticCheckbox} from 'semantic-ui-react';
import classNames from 'classnames';
import {ErrorMessage} from 'formik';

import Error from './../Error';
import {Props} from './types';

import './index.scss';

const Checkbox: React.FC<Props> = props => {
  return (
    <div className={classNames('a__checkbox', {disabled: props.disabled})}>
      <SemanticCheckbox
        label={props.label}
        disabled={props.disabled}
        className={classNames(props.className)}
        onChange={() => {
          props.form.setFieldValue(props.field.name, !props.field.value);
        }}
        checked={props.field.value}
      />
      <ErrorMessage name={props.field.name} component={Error} />
    </div>
  );
};
export default Checkbox;
